/**
 * Client entry point. Mounts <App/> into #root, wrapped in the router and the
 * toast provider. The persisted session is rehydrated from localStorage before
 * the first render so protected routes resolve correctly on a hard refresh.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import DemoLang from '@/i18n/DemoLang';
import { ToastProvider } from '@/components/Alerts/toastContext';
import { useAuthStore } from '@/store/authStore';
import './index.css';

// Rehydrate the auth session (token + cached profile) before rendering.
useAuthStore.getState().loadFromStorage();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
        <DemoLang />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);